import {
  DataloggingIcon,
  ThermometerIcon,
  QuestionIcon,
  FireExtinguisherIcon,
  CodeBranchIcon,
  BroadcastTowerIcon,
  DesktopIcon,
  TransmitterIcon,
} from 'src/components/common/icons'

export const devices = {
  modem: {
    icon: DataloggingIcon,
    i18n: 'WEB_RECEIVER',
  },
  relay: {
    icon: CodeBranchIcon,
    i18n: 'WEB_RELAY',
  },
  repeater: {
    icon: BroadcastTowerIcon,
    i18n: 'WEB_REPEATER',
  },
  sensor: {
    icon: ThermometerIcon,
    i18n: 'WEB_PROBE',
  },
  station: {
    icon: DesktopIcon,
    i18n: 'WEB_SERVER',
  },
  transmitter: {
    icon: TransmitterIcon,
    i18n: 'WEB_TRANSMITTER',
  },
  unknown: {
    icon: QuestionIcon,
    i18n: 'WEB_UNKNOWN',
  },
}

export const markers = {
  fire_extinguisher: {
    icon: FireExtinguisherIcon,
  },
}
